/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import { ConfigQuery as SourceConfigQuery } from 'SourceQuery/Config.query';
import { Field } from 'Util/Query';

/** @namespace Bookland/Query/Config/Query */
export class ConfigQuery extends SourceConfigQuery {
    getShippingLogoPath() {
        return new Field('getShippingLogoPath');
    }

    _getStoreConfigFields() {
        return [
            ...super._getStoreConfigFields(),
            'satisfly_reviewreminder_general_checkbox_message',
            'satisfly_reviewreminder_general_enable',
            'satisfly_omnibus_general_calculate_enable',
            'satisfly_omnibus_general_display_enable',
            'satisfly_askaboutproduct_general_enable',
            'satisfly_askaboutproduct_general_checkbox_message',
            'satisfly_advdiscount_general_enable',
            'satisfly_otherincategory_general_categories_to_skip',
            'satisfly_otherincategory_general_enable',
            'carriers_orlen_ruch_hints_limit',
            'carriers_orlen_ruch_hints_after_letters',
            'catalog_frontend_default_sort_by',
            'grid_per_page',
            'grid_per_page_values',
            'lbx_popups_enabled',
            'lbx_wrappers_enabled',
            'lbx_add_to_wishlist_enabled',
            'lbx_add_to_availability_list_enabled',
            'lbx_add_to_cart_enabled',
            'list_per_page',
            'list_per_page_values',
            'carriers_flatrate_logo',
            'carriers_freeshipping_logo',
            'carriers_tablerate_logo',
            'carriers_ups_logo',
            'carriers_usps_logo',
            'carriers_instore_logo',
            'carriers_courier_dhl_cod_logo',
            'carriers_courier_dpd_cod_logo',
            'carriers_fedex_logo',
            'carriers_dhl_logo',
            'carriers_dpdpickup_logo',
            'carriers_dpdcourier_logo',
            'carriers_inpostlocker_logo',
            'carriers_inpostcourier_logo',
            'carriers_courier_dhl_logo',
            'carriers_courier_dpd_logo',
            'carriers_pickup_dhl_logo',
            'carriers_orlen_ruch_logo',
            'recaptcha_frontend_type_recaptcha_v3_public_key',
            'satisfly_couponpages_student_enable',
            'satisfly_couponpages_student_code',
            'satisfly_couponpages_student_file',
            'satisfly_couponpages_coursebook_enable',
            'satisfly_couponpages_coursebook_code',
            'satisfly_couponpages_coursebook_file',
            'satisfly_productavailabilitylist_general_enable',
            'satisfly_hiddeninformationattributes_general_enable',
            'satisfly_hiddeninformationattributes_general_attribute_to_hide',
            'satisfly_schoolbook_general_pagesize',
            'satisfly_productavailabilitylist_bookstore_pick_up_time_hours',
            'satisfly_productavailabilitylist_bookstore_delivery_time_hours',
            'satisfly_productavailabilitylist_bookstore_delivery_time_status',
            'satisfly_productavailabilitylist_delivery_time_hours'
        ];
    }
}

export default new ConfigQuery();
